import plagueRequest from '../utils/plagueRequest'

export const getPlagueCourse = (data) => plagueRequest.post('/PlagueCourse/GetPlagueCourse', data)

export const getPlagueCourseDesc = (data) => plagueRequest.post('/PlagueCourse/GetPlagueCourseDesc', data)

export const fetchParishGroup = (data) => plagueRequest.post('/PlagueCourse/FetchParishGroup', data)

export const postRegistrationPlagueCourse = (data) => plagueRequest.post('/PlagueCourse/RegistrationPlagueCourse', data)

export const postSigninPlagueCourse = (data) => plagueRequest.post('/PlagueCourse/SigninPlagueCourse', data)

export const postSigninCourse = (data) => plagueRequest.post('/PlagueCourse/SigninCourse', data)

export const getSigninPlagueCourse = (data) => plagueRequest.post('/PlagueCourse/GetSigninPlagueCourse', data)
